<template>
  <el-dialog
    :modalAppendToBody="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="showDialog"
    title="导出数据"
    width="500px">
    <div class="export-dialog" v-loading="loading">
      <p style="text-align: center">说明：提交导出任务后等待5-10分钟即可查询到导出状态</p>
      <div style="text-align: center">
        <el-button @click="postExportTask" type="primary" size="small">提交导出任务</el-button>
        <el-button @click="getLastExportStatus" size="small">查询最后一次导出状态</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {fetch} from "../utils/request";
import copy from "../utils/copy";

export default {
  props: {
    exportApi: String,
    statusApi: String,
    exi_oid: String,
    query: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      showDialog: false
    }
  },
  methods: {
    open() {
      this.showDialog = true
    },
    close() {
      this.showDialog = false
    },
    getLastExportStatus() {
      this.loading = true
      fetch("post", this.statusApi, {
        exi_oid: this.exi_oid
      }).then(res => {
        if (res.status === 0) {
          this.showDialog = false
          this.$alert('<p>本次导出任务成功<br>下载地址：' + res.data + '<br>文件打包需要时间，推荐五至十分钟后下载。</p>', '下载链接地址:', {
            confirmButtonText: '复制',
            dangerouslyUseHTMLString: true,
            callback: () => {
              this.showDialog = true
              copy(res.data).then(() => {
                this.$message.success("复制成功")
              })
            }
          })
        } else {
          this.showDialog = false
          this.$alert('文件还未导出完毕，请稍后..', '提示:', {
            confirmButtonText: '确定',
            callback: () => {
              this.showDialog = true
            }
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    postExportTask() {
      this.loading = true
      fetch("post", this.exportApi, {
        exi_oid: this.exi_oid,
        ...this.query
      }).then(res => {
        this.showDialog = false
        this.$alert('<p>提交导出任务成功<br>下载地址：' + res.data + '<br>文件打包需要时间，推荐五至十分钟后下载。</p>', '下载链接地址:', {
          confirmButtonText: '复制',
          dangerouslyUseHTMLString: true,
          callback: () => {
            this.showDialog = true
            copy(res.data).then(() => {
              this.$message.success("复制成功")
            })
          }
        });
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/asyncExport.vue